import {visibilityFilter} from '../../../utils/VisibilityFilter';
import {RootState} from '../../../store';
import config from "./config";
import {Account} from "./types.ts";

const key = config.entityKey;

export const recordsSelector = (state: RootState) => {
    return state[key].records;
};

export const recordSelector = (state: RootState, id: string) => {
    const records = recordsSelector(state);
    const loading = records.loading;
    const record = records.byId[id];
    return {
        record,
        loading,
    };
};

export const selectionSelector = (state: RootState) => {
    return state[key].selection;
};

export const visibilitySelector = (state: RootState, organizationId?: string) => {
    const items = accountsSelector(state, organizationId);
    const page = state[key].visibility.page;
    const limit = state[key].visibility.limit;
    const keyword = state[key].visibility.keyword;
    const visible = state[key].visibility.visible;
    const columns = state[key].visibility.columns;

    const visibleItems = visibilityFilter<Account>(items, page, limit, keyword);

    const totalCount = state[key].records.totalCount;

    let visibleCount = totalCount;
    if (keyword) {
        visibleCount = visibleItems.length;
    }

    const totalPages = Math.ceil(visibleCount / limit);

    return {
        items: items,
        visibleItems: visibleItems,
        page: page,
        limit: limit,
        keyword: keyword,
        visible: visible,
        columns: columns,
        visibleCount: visibleCount,
        totalPages: totalPages,
    };
};

export const accountsSelector = (state: RootState, organizationId?: string) => {
    const all = state[key].records.ids.map((id: string) => {
        return state[key].records.byId[id];
    });

    if (typeof organizationId !== 'undefined') {
        // Note: organizationId filtering now handled via OrganizationAccount junction table
        return all;
    }
    return all;
};

export const accountSelector = (state: RootState, id: string) => {
    return state[key].records.byId[id];
};

export const allComponentsSelector = (state: RootState) => {
    const all = state[key].records.ids.map((id: string) => {
        return state[key].records.byId[id];
    });
    return all;
};


